import { z } from 'zod'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'

export const SchoolUserSchema = z.object({
  identifier: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  roles: z.array(z.nativeEnum(UserRole.Values)),
  gender: z.array(z.nativeEnum(UserGender.Values)).optional().nullable()
})

export type SchoolUserEntity = z.infer<typeof SchoolUserSchema>
